/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userProfileUpdate.internal

import features.userProfileUpdate.models.UpdateUserProfileRequest
import features.userProfileUpdate.models.UserProfileModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class UserProfileUpdateRequest : NetworkRequest() {

    suspend fun updateUserProfile(
        overrideHeaders: Map<String, String>? = null,
        updateUserProfileRequest: UpdateUserProfileRequest
    ): IOResult<UserProfileModel> {
        return safeNetworkCall {
            patch<UserProfileModel, UpdateUserProfileRequest>(
                endpoint = UserProfileUpdateEndpoint,
                requestBody = updateUserProfileRequest,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
